(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-stick-pack"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Open popup on item click
  document.querySelectorAll('.animation-content-item-mobile').forEach(item => {
    item.addEventListener('click', function () {
      const nextEl = this.nextElementSibling;
      if (nextEl && nextEl.classList.contains('animation-content-popup')) {
        nextEl.classList.add('open');
      }
    });
  });

  // Close popup on close button click
  document.querySelectorAll('.popup-close').forEach(closeBtn => {
    closeBtn.addEventListener('click', function () {
      const popup = this.closest('.animation-content-popup');
      if (popup) {
        popup.classList.remove('open');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var r=document.getElementById('igStories');if(!r)return;
    var t=r.querySelector('.ig-track'),p=r.querySelector('.ig-prev'),n=r.querySelector('.ig-next');
    function st(){var c=t.querySelector('.ig-card');return c?c.offsetWidth+18:300;}
    function u(){var o=t.scrollWidth-t.clientWidth>4;t.classList.toggle('is-center',!o);p.hidden=!o||t.scrollLeft<4;n.hidden=!o||t.scrollLeft+t.clientWidth>=t.scrollWidth-4;}
    p.addEventListener('click',function(){t.scrollBy({left:-st(),behavior:'smooth'});});
    n.addEventListener('click',function(){t.scrollBy({left:st(),behavior:'smooth'});});
    t.addEventListener('scroll',u,{passive:true});window.addEventListener('resize',u);
    t.querySelectorAll('img').forEach(function(i){if(!i.complete)i.addEventListener('load',u);});u();
    var lb=document.createElement('div');lb.className='ig-lb';lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');lb.setAttribute('aria-label','Instagram post');
    lb.innerHTML='<div class="ig-lb-stage"><img alt="" draggable="false"></div><button class="ig-lb-btn ig-lb-close" type="button" aria-label="Close">&#10005;</button><button class="ig-lb-btn ig-lb-prev" type="button" aria-label="Previous">&#8592;</button><button class="ig-lb-btn ig-lb-next" type="button" aria-label="Next">&#8594;</button><div class="ig-lb-zoom"><button type="button" class="ig-zo" aria-label="Zoom out">&minus;</button><button type="button" class="ig-zr" aria-label="Reset zoom">1x</button><button type="button" class="ig-zi" aria-label="Zoom in">+</button></div><div class="ig-lb-count"></div><div class="ig-lb-hint"></div>';
    document.body.appendChild(lb);
    var imgs=[].slice.call(t.querySelectorAll('.ig-card img')),stage=lb.querySelector('.ig-lb-stage'),li=lb.querySelector('img'),cnt=lb.querySelector('.ig-lb-count'),zr=lb.querySelector('.ig-zr'),hint=lb.querySelector('.ig-lb-hint'),cur=0,last=null;
    var touch=window.matchMedia('(hover:none)').matches;hint.textContent=touch?'Pinch or double tap to zoom':'Scroll or double click to zoom. Drag to move.';
    var lastType='mouse',moved=false,S=1,X=0,Y=0,MAX=4,pts={},pinch=null,pan=null,down=null,lastTap=0;
    function clamp(){var r=li.getBoundingClientRect(),w=li.offsetWidth,h=li.offsetHeight,mx=w*(S-1)/2,my=h*(S-1)/2;X=Math.max(-mx,Math.min(mx,X));Y=Math.max(-my,Math.min(my,Y));}
    function apply(anim){li.style.transition=anim?'transform .2s ease':'none';if(S<=1.001){S=1;X=0;Y=0;}clamp();li.style.transform='translate('+X+'px,'+Y+'px) scale('+S+')';zr.textContent=(Math.round(S*10)/10)+'x';lb.classList.toggle('zoomed',S>1);}
    function zoomAt(ns,cx,cy,anim){ns=Math.max(1,Math.min(MAX,ns));var r=stage.getBoundingClientRect(),ox=cx-(r.left+r.width/2),oy=cy-(r.top+r.height/2),k=ns/S;X=ox-(ox-X)*k;Y=oy-(oy-Y)*k;S=ns;apply(anim);}
    function center(){var r=stage.getBoundingClientRect();return [r.left+r.width/2,r.top+r.height/2];}
    function show(k){cur=(k+imgs.length)%imgs.length;S=1;X=0;Y=0;apply(false);li.src=imgs[cur].src.replace(/([?&])width=\d+/,'$1width=1600');li.alt=imgs[cur].alt;cnt.textContent=(cur+1)+' / '+imgs.length;}
    function open(k){last=document.activeElement;show(k);lb.classList.add('open');document.documentElement.style.overflow='hidden';lb.querySelector('.ig-lb-close').focus();}
    function close(){lb.classList.remove('open');document.documentElement.style.overflow='';if(last)last.focus();}
    [].slice.call(t.querySelectorAll('.ig-card')).forEach(function(c,k){c.addEventListener('click',function(){open(k);});});
    lb.querySelector('.ig-lb-close').addEventListener('click',close);
    lb.querySelector('.ig-lb-prev').addEventListener('click',function(e){e.stopPropagation();show(cur-1);});
    lb.querySelector('.ig-lb-next').addEventListener('click',function(e){e.stopPropagation();show(cur+1);});
    lb.querySelector('.ig-zi').addEventListener('click',function(e){e.stopPropagation();var c=center();zoomAt(S+0.75,c[0],c[1],true);});
    lb.querySelector('.ig-zo').addEventListener('click',function(e){e.stopPropagation();var c=center();zoomAt(S-0.75,c[0],c[1],true);});
    zr.addEventListener('click',function(e){e.stopPropagation();S=1;apply(true);});
    lb.addEventListener('click',function(e){if(moved){moved=false;return;}if(e.target===lb||e.target===stage){if(S===1)close();}});
    document.addEventListener('keydown',function(e){if(!lb.classList.contains('open'))return;if(e.key==='Escape')close();if(e.key==='ArrowLeft')show(cur-1);if(e.key==='ArrowRight')show(cur+1);if(e.key==='+'||e.key==='='){var c=center();zoomAt(S+0.75,c[0],c[1],true);}if(e.key==='-'){var c2=center();zoomAt(S-0.75,c2[0],c2[1],true);}});
    stage.addEventListener('wheel',function(e){e.preventDefault();zoomAt(S*(e.deltaY<0?1.15:1/1.15),e.clientX,e.clientY,false);},{passive:false});
    stage.addEventListener('dblclick',function(e){if(lastType==='touch'||e.target.closest('button'))return;e.preventDefault();if(S>1){S=1;apply(true);}else zoomAt(2.5,e.clientX,e.clientY,true);});
    function dist(){var v=Object.keys(pts).map(function(k){return pts[k];});return Math.hypot(v[0].x-v[1].x,v[0].y-v[1].y);}
    function mid(){var v=Object.keys(pts).map(function(k){return pts[k];});return [(v[0].x+v[1].x)/2,(v[0].y+v[1].y)/2];}
    stage.addEventListener('pointerdown',function(e){if(e.target.closest('button'))return;lastType=e.pointerType;pts[e.pointerId]={x:e.clientX,y:e.clientY};var n=Object.keys(pts).length;
      if(n===2){pinch={d:dist(),s:S};pan=null;down=null;}
      else if(n===1){down={x:e.clientX,y:e.clientY,t:Date.now()};pan={x:e.clientX,y:e.clientY,X:X,Y:Y};}});
    stage.addEventListener('pointermove',function(e){if(!pts[e.pointerId])return;pts[e.pointerId]={x:e.clientX,y:e.clientY};
      if(pinch&&Object.keys(pts).length===2){var m=mid();zoomAt(pinch.s*dist()/pinch.d,m[0],m[1],false);}
      else if(pan&&S>1){X=pan.X+(e.clientX-pan.x);Y=pan.Y+(e.clientY-pan.y);apply(false);}});
    function up(e){if(!pts[e.pointerId])return;delete pts[e.pointerId];var n=Object.keys(pts).length;
      if(n<2)pinch=null;
      if(n===0&&down){var dx=e.clientX-down.x,dy=e.clientY-down.y,quick=Date.now()-down.t<300;moved=Math.abs(dx)>10||Math.abs(dy)>10;
        if(S===1&&Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))show(cur+(dx<0?1:-1));
        else if(e.pointerType==='touch'&&quick&&Math.abs(dx)<10&&Math.abs(dy)<10){var now=Date.now();if(now-lastTap<300){if(S>1){S=1;apply(true);}else zoomAt(2.5,e.clientX,e.clientY,true);lastTap=0;}else lastTap=now;}
        down=null;}
      if(n===1){var k=Object.keys(pts)[0];pan={x:pts[k].x,y:pts[k].y,X:X,Y:Y};}}
    stage.addEventListener('pointerup',up);stage.addEventListener('pointercancel',up);
    window.addEventListener('resize',function(){if(lb.classList.contains('open'))apply(false);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-problem"] && !Shopify.designMode) return;
  try {
    
var tally=document.getElementById('symTally');
document.querySelectorAll('#symGrid .sym').forEach(function(c){
  c.addEventListener('click',function(){
    c.classList.toggle('on');
    var n=document.querySelectorAll('#symGrid .sym.on').length;
    tally.classList.toggle('hot',n>=3);
    if(n===0){tally.innerHTML='Check any that apply and we will tell you what it usually means.';}
    else if(n<3){tally.innerHTML='<b>'+n+' of 6.</b> Worth paying attention to. Every one of these shows up when water and minerals run low.';}
    else{tally.innerHTML='<b>'+n+' of 6.</b> That is the pattern we hear about most. Low water and low minerals cause all six, which is why they tend to show up together.';}
  });
});

  } catch(e) { console.error(e); }
})();
})();
